var map = {
	"./en-us/resource": 134,
	"./es-us/resource": 136,
	"./pt-br/resource": 138,
	"./zh-cn/resource": 140
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 354;


//////////////////
// WEBPACK FOOTER
// ./public/hws/i18n ^\.\/.*\/resource$
// module id = 354
// module chunks = 0